<template>
  <div :menu-fix="false">
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.saleSettlements'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="settleObjForm"
          :model="settleObj"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.title')">{{
                    settleObj.title
                  }}</el-form-item>
                </el-col>

                <!-- <el-col :span="8">
                  <el-form-item :label="$t('settlement.amount')">
                    {{ settleObj.settleAmount | currency }}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('settlement.orderQuantity')">
                    {{ orders.length }}
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$t('settlement.searchCondition')">{{
                    settleObj.searchCondition
                  }}</el-form-item>
                </el-col>
              </el-row>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("action.payment") }}{{ $t("text.detail") }}</legend>
              <vxe-table
                :data="payments"
                ref="itemsTable"
                class="recordsTable"
                size="mini"
                highlight-hover-row
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column field="total" :title="$t('payment.total')">
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.total }}
                    <div class="font10">{{ row.cnyTotal | currency }}</div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="payMethodName"
                  :title="$t('payment.payMethod')"
                ></vxe-table-column>
                <vxe-table-column
                  field="paidAt"
                  :title="$t('payment.paidAt')"
                  width="110px"
                ></vxe-table-column>
                <vxe-table-column
                  field="ownerName"
                  :title="$t('payment.ownerName')"
                ></vxe-table-column>
                <vxe-table-column
                  field="voucher"
                  :title="$t('payment.voucher')"
                >
                  <template v-slot="{ row }">
                    <thumbnail-text :srcs="row.voucher" />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="explain"
                  :title="$t('payment.explain')"
                ></vxe-table-column>
                <vxe-table-column
                  field="row.bargain"
                  :title="$t('bargain.serialNo')"
                >
                  <template v-slot="{ row }">
                    <el-popover
                      placement="right"
                      width="800"
                      trigger="click"
                      @show="getCurrentRowOrder(row)"
                    >
                      <vxe-table
                        :data="currentRowOrders"
                        ref="itemsTable"
                        class="recordsTable"
                        size="mini"
                        :scroll-y="{ enabled: false }"
                        highlight-hover-row
                      >
                        <vxe-table-column
                          field="images"
                          :title="$t('product.images')"
                          width="85"
                        >
                          <template v-slot="{ row }">
                            <thumbnail :images="row.images"></thumbnail>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="serialNo"
                          :title="$t('text.serialNo')"
                          min-width="100"
                        >
                          <template v-slot="{ row }">
                            <div @click="showOrder(row)" class="blue">
                              {{ row.serialNo }}
                            </div>
                            <div>
                              <state-label :state="row.workflowState">{{
                                $t("orderStates." + row.workflowState)
                              }}</state-label>
                            </div>
                          </template>
                        </vxe-table-column>

                        <vxe-table-column
                          field="createAt"
                          :title="$t('text.createAt')"
                          min-width="90"
                        >
                          <template v-slot="{ row }">
                            {{ row.createAt }}
                            <div class="font10">
                              {{ $t("text.handOverAt2") }}:{{ row.handOverAt }}
                            </div>
                          </template>
                        </vxe-table-column>

                        <vxe-table-column
                          field="finishAt"
                          :title="$t('rework.finishAt')"
                          min-width="150"
                        >
                          <template v-slot="{ row }">
                            <div class="font10">
                              {{ $t("order.finishAt") }}:{{ row.finishAt }}
                            </div>
                            <div class="font10">
                              {{ $t("order.customerReceiveAt2") }}:{{
                                row.customerReceiveAt
                              }}
                            </div>
                          </template>
                        </vxe-table-column>

                        <vxe-table-column
                          field="productNo"
                          :title="$t('product.productNo')"
                          min-width="100"
                        >
                          <template v-slot="{ row }">
                            {{ row.productNo }}
                            <div class="font10">
                              {{ row.color }} {{ row.size }}
                            </div>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          field="quantity"
                          :title="$t('text.quantity')"
                          min-width="100"
                        >
                          <template v-slot="{ row }">
                            {{ row.quantity }}{{ row.unit }}
                            <div class="font10">
                              {{ $t("order.delivered") }}:
                              {{ row.deliveredQuantity }}{{ row.unit }}
                            </div>
                            <div class="font10">
                              {{ $t("order.price") }}:<currency
                                :code="row.currency"
                              ></currency>
                              {{ row.price }}
                            </div>
                            <div
                              v-if="
                                row.extraCharge != null && row.extraCharge != 0
                              "
                              class="font10"
                            >
                              {{ $t("order.extraCharge") }}:<currency
                                :code="row.currency"
                              ></currency>
                              {{ row.extraCharge }}
                            </div>
                          </template>
                        </vxe-table-column>
                        <vxe-table-column
                          :title="$t('order.subtotal')"
                          min-width="80"
                        >
                          <template v-slot="{ row }">
                            <currency :code="row.currency"></currency>
                            {{ row.price * row.quantity + row.extraCharge }}
                          </template>
                        </vxe-table-column>

                        <vxe-table-column
                          :title="$t('order.settlementRemark')"
                          min-width="80"
                        >
                          <template v-slot="{ row }">
                            <raw-html-limit-number
                              :content="row.settlementRemark"
                              :number="8"
                            />
                          </template>
                        </vxe-table-column>
                      </vxe-table>
                      <span slot="reference" class="popover-reference">
                        {{ row.bargain.serialNo }}
                      </span>
                    </el-popover>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
            <!-- <fieldset class="mgb15">
              <legend>{{ $t("menu.orders") }}{{ $t("text.detail") }}</legend>
              <vxe-table
                :data="orders"
                ref="itemsTable"
                class="recordsTable"
                size="mini"
                :scroll-y="{ enabled: false }"
                highlight-hover-row
              >
                <vxe-table-column
                  field="images"
                  :title="$t('product.images')"
                  width="85"
                >
                  <template v-slot="{ row }">
                    <thumbnail :images="row.images"></thumbnail>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="serialNo"
                  :title="$t('text.serialNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <div @click="showOrder(row)" class="blue">
                      {{ row.serialNo }}
                    </div>
                    <div>
                      <state-label :state="row.workflowState">{{
                        $t("orderStates." + row.workflowState)
                      }}</state-label>
                    </div>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="createAt"
                  :title="$t('text.createAt')"
                  min-width="90"
                >
                  <template v-slot="{ row }">
                    {{ row.createAt }}
                    <div class="font10">
                      {{ $t("text.handOverAt2") }}:{{ row.handOverAt }}
                    </div>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="finishAt"
                  :title="$t('rework.finishAt')"
                  min-width="150"
                >
                  <template v-slot="{ row }">
                    <div class="font10">
                      {{ $t("order.finishAt") }}:{{ row.finishAt }}
                    </div>
                    <div class="font10">
                      {{ $t("order.customerReceiveAt2") }}:{{
                        row.customerReceiveAt
                      }}
                    </div>
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  field="productNo"
                  :title="$t('product.productNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.productNo }}
                    <div class="font10">{{ row.color }} {{ row.size }}</div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="quantity"
                  :title="$t('text.quantity')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.quantity }}{{ row.unit }}
                    <div class="font10">
                      {{ $t("order.delivered") }}: {{ row.deliveredQuantity
                      }}{{ row.unit }}
                    </div>
                    <div class="font10">
                      {{ $t("order.price") }}:<currency
                        :code="row.currency"
                      ></currency>
                      {{ row.price }}
                    </div>
                    <div
                      v-if="row.extraCharge != null && row.extraCharge != 0"
                      class="font10"
                    >
                      {{ $t("order.extraCharge") }}:<currency
                        :code="row.currency"
                      ></currency>
                      {{ row.extraCharge }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column :title="$t('order.subtotal')" min-width="80">
                  <template v-slot="{ row }">
                    <currency :code="row.currency"></currency>
                    {{ row.price * row.quantity + row.extraCharge }}
                  </template>
                </vxe-table-column>

                <vxe-table-column
                  :title="$t('order.settlementRemark')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <raw-html-limit-number
                      :content="row.settlementRemark"
                      :number="8"
                    />
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset> -->
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ls from "store2";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import ThumbnailText from "@/components/ThumbnailText";
import Currency from "@/components/Currency";

//
import Payment from "@/api/payment.js";
import SaleSettlement from "@/api/saleSettlement.js";

export default {
  mixins: [page],
  components: {
    BackButton,
    ThumbnailText,
    Currency,
  },
  data() {
    return {
      payments: [],
      orders: [],
      Util: Util,
      settleObj: {
        title: null,
        paymentIds: [],
        searchCondition: null,
        settleAmount: null,
      },
      currentRowOrders: [],

      saveDoing: false,
    };
  },
  mounted() {},
  created() {
    const self = this;
    self.settleObj.searchCondition =
      "收款日期:" +
      self.$route.query.paidAtStartAt +
      "~" +
      self.$route.query.paidAtEndAt;

    self.loadingStart();
    self.settleObj.title = self.$route.params.title;
    axios.all([Payment.unSaleSettle(self.$route.query)]).then(
      axios.spread(function (payments) {
        self.loadingEnd();
        if (payments.status === 200) {
          self.payments = payments.data.payments;
          self.orders = payments.data.orders;
          // self.computeAmount();
        } else {
          self.sysError();
        }
      })
    );
  },

  methods: {
    getCurrentRowOrder(row) {
      this.currentRowOrders = this.orders.filter(
        (o) => o.bargainId == row.bargainId
      );
    },
    // remove(row, rowIndex) {
    //   this.orders.splice(rowIndex, 1);
    //   this.computeAmount();
    // },
    // computeAmount() {
    //   const self = this;
    //   self.settleObj.settleAmount = 0;
    //   self.settleObj.productQuantity = 0;
    //   for (const order of self.orders) {
    //     self.settleObj.settleAmount =
    //       Number(order.factorySettleAmount) + self.settleObj.settleAmount;
    //     self.settleObj._productQuantity =
    //       order.quantity + self.settleObj._productQuantity;
    //   }
    //   self.settleObj._orderQuantity = self.orders.length;
    // },
    //
    saveSubmit() {
      let self = this;
      if (self.payments.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      self.settleObj.paymentIds = self.payments.map((p) => p.id);
      self.saveDoing = true;
      SaleSettlement.create(self.settleObj).then(function (res) {
        self.saveDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.$router.push({ name: "fnReportsSaleSettlements" });
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>